import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'

import { ListItem } from '@tiptap/extension-list-item'
import { Fragment } from '@tiptap/pm/model'

const CustomListItem = ListItem.extend({
	content: 'inline*', // <li> bevat direct inline content

	parseHTML() {
		return [
			{
				tag: 'li',
				getContent(node, schema) {
					const content = []

					node.childNodes.forEach(child => {
						if (child.nodeType === Node.TEXT_NODE) {
							content.push(schema.text(child.textContent))
						}

						if (child.nodeName === 'P') {
							child.childNodes.forEach(textNode => {
								if (textNode.nodeType === Node.TEXT_NODE) {
									content.push(schema.text(textNode.textContent))
								}
							})
						}
					})

					return Fragment.from(content)
				},
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return ['li', HTMLAttributes, 0]
	},
})


function initTiptapEditors() {
	const editorElements = document.querySelectorAll('.tiptap-editor')

	editorElements.forEach((el) => {
		const editorId = el.getAttribute('id')
		const hiddenField = document.getElementById(editorId + '_hidden')
		const toolbar = document.querySelector(`.tiptap-toolbar[data-editor-id="${editorId}"]`)

		const editor = new Editor({
			element: el, // bind aan bestaande DOM node
			extensions: [
				StarterKit.configure({
					heading: {
						levels: [1, 2, 3],
					},
					listItem: false
				}),
				CustomListItem
			],
			content: hiddenField.value || '<p></p>',
			autofocus: false,
			editable: true,
			injectCSS: true, // TipTap’s basis CSS gebruiken
			onUpdate({ editor }) {
				hiddenField.value = editor.getHTML()
			},
		})

		// Toolbar acties
		if (toolbar) {
			toolbar.addEventListener('click', (event) => {
				const button = event.target.closest('button')
				if (!button) return

				const action = button.dataset.action
				const level = button.dataset.level ? parseInt(button.dataset.level, 10) : null

				switch (action) {
					case 'toggleBold':
						editor.chain().focus().toggleBold().run()
						break
					case 'toggleItalic':
						editor.chain().focus().toggleItalic().run()
						break
					case 'toggleStrike':
						editor.chain().focus().toggleStrike().run()
						break
					case 'toggleCode':
						editor.chain().focus().toggleCode().run()
						break
					case 'setParagraph':
						editor.chain().focus().setParagraph().run()
						break
					case 'toggleHeading':
						editor.chain().focus().toggleHeading({ level }).run()
						break
					case 'toggleBulletList':
						editor.chain().focus().toggleBulletList().run()
						break
					case 'toggleOrderedList':
						editor.chain().focus().toggleOrderedList().run()
						break
					case 'toggleBlockquote':
						editor.chain().focus().toggleBlockquote().run()
						break
					case 'toggleCodeBlock':
						editor.chain().focus().toggleCodeBlock().run()
						break
					case 'setLink': {
						const url = window.prompt('URL invoeren')
						if (url) {
							editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
						}
						break
					}
					case 'unsetLink':
						editor.chain().focus().unsetLink().run()
						break
				}
			})
		}
	})
}

document.addEventListener('DOMContentLoaded', initTiptapEditors)
